import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '~/constants/routes'

import { PUBLICATION_STATE } from './Listings.constants'
import translations from './pages/index/Index.translations'

function onboardingRoutes(): RouteRecordRaw[] {
  return [
    {
      redirect: { name: ROUTE_NAMES.ONBOARDING.LISTINGS.TABS.ACTIVE },
      name: ROUTE_NAMES.ONBOARDING.LISTINGS.INDEX,
      component: () => import('./pages/index/Index.vue'),
      path: '/bo-seller/onboarding/listings',
      meta: {
        autonomousBannerPageName: 'onboarding-listings',
        owners: ['bot-squad-seller-experience-front'],
      },
      children: [
        {
          component: () => import('./pages/index/components/Tab/Tab.vue'),
          name: ROUTE_NAMES.ONBOARDING.LISTINGS.TABS.ACTIVE,
          path: 'active',
          meta: {
            publicationState: PUBLICATION_STATE.ONLINE,
            autonomousBannerPageName: 'onboarding-listings.active',
            tabItem: {
              label: translations.tabActive,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () => import('./pages/index/components/Tab/Tab.vue'),
          name: ROUTE_NAMES.ONBOARDING.LISTINGS.TABS.MISSING_INFOS,
          path: 'missing-infos',
          meta: {
            publicationState: PUBLICATION_STATE.MISSING_PRICE_OR_COMMENT,
            autonomousBannerPageName: 'onboarding-listings.missing-infos',
            tabItem: {
              label: translations.tabMissingInfos,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () => import('./pages/index/components/Tab/Tab.vue'),
          name: ROUTE_NAMES.ONBOARDING.LISTINGS.TABS.IN_VALIDATION,
          path: 'in-validation',
          meta: {
            publicationState: PUBLICATION_STATE.IN_VALIDATION,
            autonomousBannerPageName: 'onboarding-listings.in-validation',
            tabItem: {
              label: translations.tabInValidation,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () => import('./pages/index/components/Tab/Tab.vue'),
          name: ROUTE_NAMES.ONBOARDING.LISTINGS.TABS.ARCHIVED,
          path: 'archived',
          meta: {
            publicationState: PUBLICATION_STATE.DISABLED,
            autonomousBannerPageName: 'onboarding-listings.archived',
            tabItem: {
              label: translations.tabArchived,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
      ],
    },
    {
      path: '/bo-seller/onboarding/listings/product/search',
      name: ROUTE_NAMES.ONBOARDING.LISTINGS.CREATE.PRODUCT.SEARCH,
      component: () => import('./pages/product-search/ProductSearch.vue'),
      meta: {
        owners: ['bot-squad-seller-experience-front'],
      },
    },
    {
      path: '/bo-seller/onboarding/listings/create/:productId',
      name: ROUTE_NAMES.ONBOARDING.LISTINGS.CREATE.DETAILS,
      component: () => import('./pages/create/Create.vue'),
      meta: {
        owners: ['bot-squad-seller-experience-front'],
      },
    },
    {
      redirect: {
        name: ROUTE_NAMES.BADOOM.LISTINGS.PRODUCT.DUPLICATE,
      },
      name: ROUTE_NAMES.ONBOARDING.LISTINGS.CREATE.PRODUCT.DUPLICATE,
      path: '/bo-seller/onboarding/duplicate_product/:productId',
    },
  ]
}

const routes = (): RouteRecordRaw[] => {
  const {
    FF_BO_SELLER_IS_NEW_LISTING_CREATE_PRODUCT_DUPLICATE_OPEN,
    FF_BO_SELLER_IS_NEW_LISTING_CREATE_PRODUCT_OPEN,
  } = useRuntimeConfig()

  return [
    ...onboardingRoutes(),
    {
      path: '/bo-seller/listings',
      name: ROUTE_NAMES.LISTINGS.INDEX,
      component: () => import('./pages/index/Index.vue'),
      redirect: { name: ROUTE_NAMES.LISTINGS.TABS.ACTIVE },
      meta: {
        autonomousBannerPageName: 'listings',
        owners: ['bot-squad-seller-experience-front'],
      },
      children: [
        {
          path: 'active',
          name: ROUTE_NAMES.LISTINGS.TABS.ACTIVE,
          meta: {
            publicationState: PUBLICATION_STATE.ONLINE,
            autonomousBannerPageName: 'listings.active',
            tabItem: {
              label: translations.tabActive,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
          component: () => import('./pages/index/components/Tab/Tab.vue'),
        },
        {
          path: 'missing-infos',
          name: ROUTE_NAMES.LISTINGS.TABS.MISSING_INFOS,
          meta: {
            publicationState: PUBLICATION_STATE.MISSING_PRICE_OR_COMMENT,
            autonomousBannerPageName: 'listings.missing-infos',
            tabItem: {
              label: translations.tabMissingInfos,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
          component: () => import('./pages/index/components/Tab/Tab.vue'),
        },
        {
          path: 'in-validation',
          name: ROUTE_NAMES.LISTINGS.TABS.IN_VALIDATION,
          meta: {
            publicationState: PUBLICATION_STATE.IN_VALIDATION,
            autonomousBannerPageName: 'listings.in-validation',
            tabItem: {
              label: translations.tabInValidation,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
          component: () => import('./pages/index/components/Tab/Tab.vue'),
        },
        {
          path: 'archived',
          name: ROUTE_NAMES.LISTINGS.TABS.ARCHIVED,
          meta: {
            publicationState: PUBLICATION_STATE.DISABLED,
            autonomousBannerPageName: 'listings.archived',
            tabItem: {
              label: translations.tabArchived,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
          component: () => import('./pages/index/components/Tab/Tab.vue'),
        },
      ],
    },
    {
      path: '/bo-seller/listings/product/search',
      name: ROUTE_NAMES.LISTINGS.PRODUCT.SEARCH,
      component: () => import('./pages/product-search/ProductSearch.vue'),
      meta: {
        owners: ['bot-squad-seller-experience-front'],
      },
    },
    {
      path: '/bo-seller/listings/create/:productId',
      name: ROUTE_NAMES.LISTINGS.CREATE,
      component: () => import('./pages/create/Create.vue'),
      meta: {
        owners: ['bot-squad-seller-experience-front'],
      },
    },
    {
      path: '/bo-seller/listings/product/create',
      ...(FF_BO_SELLER_IS_NEW_LISTING_CREATE_PRODUCT_OPEN
        ? {
            component: () => import('./pages/product-create/ProductCreate.vue'),
          }
        : {
            redirect: {
              name: ROUTE_NAMES.BADOOM.LISTINGS.PRODUCT.CREATE,
            },
          }),

      name: ROUTE_NAMES.LISTINGS.PRODUCT.CREATE,
      meta: {
        owners: ['bot-squad-seller-experience-front'],
      },
    },
    {
      path: '/bo-seller/listings/product/duplicate/:productId',
      name: ROUTE_NAMES.LISTINGS.PRODUCT.DUPLICATE,
      ...(FF_BO_SELLER_IS_NEW_LISTING_CREATE_PRODUCT_DUPLICATE_OPEN
        ? {
            component: () =>
              import('./pages/product-duplicate/ProductDuplicate.vue'),
          }
        : {
            redirect: {
              name: ROUTE_NAMES.BADOOM.LISTINGS.PRODUCT.DUPLICATE,
            },
          }),
      meta: {
        owners: ['bot-squad-seller-experience-front'],
      },
    },
  ]
}

export default routes
